import './translations';
let initialized = false;
export default function initialize() {
    if (initialized) {
        throw new Error('finance already initialized');
    }
    initialized = true;
    // ...
}
